import { Injectable, inject } from '@angular/core';
import { FeatureTogglesConfigLoaderService } from '@ceres/feature-toggles';
import { ENVIRONMENT } from '@ceres/frontend-helper';
import FEATURES, { CeresFeaturesConfig, mergeFlatFlagsIntoFeatures, RawFeatureProfiles } from '@ceres/shared/features';
import { ImpersonatedHttpClient } from '@ceres/shared/services';
import { Observable, catchError, map, of, timeout } from 'rxjs';

const FEATURE_CONFIG_TIMEOUT_MS = 10000;

@Injectable()
export class AppConfigFeaturesAdapterService extends FeatureTogglesConfigLoaderService<CeresFeaturesConfig> {
    private readonly http = inject(ImpersonatedHttpClient);
    private readonly environment = inject<{ edgeService: string }>(ENVIRONMENT);

    public override loadFeatureConfig(): Observable<CeresFeaturesConfig> {
        return this.http.get<RawFeatureProfiles>(`${this.environment.edgeService}/features`).pipe(
            timeout(FEATURE_CONFIG_TIMEOUT_MS),
            map((raw) =>
                mergeFlatFlagsIntoFeatures(FEATURES, raw, (path) =>
                    console.warn(`Skipping AppConfig flag without an existing boolean feature path: ${path}`)
                )
            ),
            catchError((error: unknown) => {
                console.warn('Failed to load AppConfig features; using static FEATURES.', error);
                return of(FEATURES);
            })
        );
    }
}
